import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "clearfix"
}
const _hoisted_2 = {
  key: 1,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing"
}
const _hoisted_3 = { class: "card-head box-shadow bg-white d-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 gap-10" }
const _hoisted_4 = {
  class: "position-relative",
  style: {"min-width":"220px","max-width":"300px","flex":"1 1 auto"}
}
const _hoisted_5 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_8 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_9 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_10 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_11 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_12 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_14 = {
  key: 0,
  class: "pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center"
}
const _hoisted_15 = {
  key: 0,
  class: "mb-0 text-paragraph"
}
const _hoisted_16 = { class: "fw-bold" }
const _hoisted_17 = { class: "fw-bold" }
const _hoisted_18 = {
  key: 1,
  class: "mb-0 text-paragraph"
}
const _hoisted_19 = { class: "fw-bold" }
const _hoisted_20 = { class: "fw-bold" }
const _hoisted_21 = { class: "mt-15 mt-md-0" }
const _hoisted_22 = { class: "pagination mb-0" }
const _hoisted_23 = {
  key: 0,
  class: "page-item"
}
const _hoisted_24 = {
  key: 0,
  class: "page-link active",
  href: "#"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 1,
  class: "page-item"
}
const _hoisted_27 = {
  class: "modal fade",
  id: "companyModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_28 = { class: "modal-dialog modal-lg modal-dialog-centered" }
const _hoisted_29 = { class: "modal-content" }
const _hoisted_30 = { class: "modal-header" }
const _hoisted_31 = { class: "modal-title fs-5" }
const _hoisted_32 = { class: "modal-body" }
const _hoisted_33 = {
  key: 0,
  style: {"margin-top":"5%"}
}
const _hoisted_34 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_35 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_36 = {
  key: 1,
  style: {"margin-top":"5%"}
}
const _hoisted_37 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"green"}
}
const _hoisted_38 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = { class: "col-md-6" }
const _hoisted_41 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_42 = ["placeholder"]
const _hoisted_43 = { class: "invalid-feedback" }
const _hoisted_44 = { class: "col-md-6" }
const _hoisted_45 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_46 = ["placeholder"]
const _hoisted_47 = { class: "invalid-feedback" }
const _hoisted_48 = { class: "row" }
const _hoisted_49 = { class: "col-md-6" }
const _hoisted_50 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_51 = ["selected"]
const _hoisted_52 = ["selected"]
const _hoisted_53 = ["selected"]
const _hoisted_54 = { class: "col-md-6" }
const _hoisted_55 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_56 = ["placeholder"]
const _hoisted_57 = { class: "invalid-feedback" }
const _hoisted_58 = { class: "row" }
const _hoisted_59 = { class: "col-md-6" }
const _hoisted_60 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_61 = ["placeholder"]
const _hoisted_62 = { class: "invalid-feedback" }
const _hoisted_63 = { class: "col-md-6" }
const _hoisted_64 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_65 = ["selected"]
const _hoisted_66 = ["selected"]
const _hoisted_67 = ["selected"]
const _hoisted_68 = ["selected"]
const _hoisted_69 = { class: "row" }
const _hoisted_70 = { class: "col-md-6" }
const _hoisted_71 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_72 = { value: "" }
const _hoisted_73 = ["value", "selected"]
const _hoisted_74 = { class: "col-md-6" }
const _hoisted_75 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_76 = ["selected"]
const _hoisted_77 = { value: false }
const _hoisted_78 = { value: true }
const _hoisted_79 = { class: "row" }
const _hoisted_80 = { class: "col-md-6" }
const _hoisted_81 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_82 = ["placeholder"]
const _hoisted_83 = { class: "invalid-feedback" }
const _hoisted_84 = { class: "col-md-6" }
const _hoisted_85 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_86 = { value: "" }
const _hoisted_87 = ["value", "selected"]
const _hoisted_88 = { class: "row" }
const _hoisted_89 = { class: "col-md-12" }
const _hoisted_90 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_91 = ["placeholder"]
const _hoisted_92 = { class: "invalid-feedback" }
const _hoisted_93 = { class: "modal-footer" }
const _hoisted_94 = {
  key: 0,
  type: "submit",
  class: "btn text-white",
  style: {"background-color":"#EB9355"}
}

import {ref, onMounted,reactive,inject } from "vue";
import axios from 'axios';
import router from '../../router/index'
import {showToast,checkSessionValidate} from "../../utils/function";
import {current_permissions} from '../../utils/permission';
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from "vue-i18n";
import * as yup from 'yup';
import { Country,Fee,Operator,Organization,TypeFree, Provider, Actions } from "@/utils/Model";
import { getTypeFee } from "../../utils/services";
import { useTableFilter } from "../../utils/UseTablefilter";


export default /*@__PURE__*/_defineComponent({
  __name: 'ActionsContent',
  setup(__props) {

const backApi=inject('back');
const page = ref(1);
const total = ref(0);
const pagesLeft = ref(0);
const currentPage = ref(0);
const numPages = ref(0);
let edit = 0;
let itemCode = '';
let code:string|null='';
const selectedOrganization = ref(code);
const selectedOperator = ref('');
const selectedCountry = ref('');
const selectedTypeFee = ref('');
const selectedMode = ref('');
const btnLoad = ref(true);
const { t } = useI18n();


const selectedStatus = ref('');
const selectedPaymentMethod = ref('');
const selectedOperationType = ref('');
const selectedCheckOnlyAfterTimeout = ref(false);
const selectedProvider = ref('');

let countryCode = ''
let countryName = ''


const loader = ref(false);

let token: string|null = localStorage.getItem('login_token');


const countries =ref(new Array<Country>());
const fees =ref(new Array<Fee>());
const organizations =ref(new Array<Organization>());
const operators =ref(new Array<Operator>());
const providers =ref(new Array<Provider>());
// const typefees =ref([]);
const typefees =ref(new Array<TypeFree>());
let operatorsTemp =new Array<Operator>();
const actions = ref(new Array<Actions>());
let countriesTemp =new Array<Country>();

// Recherche + pagination sur la liste des actions (comme sur la page providers)
const {
  searchQuery,
  paginatedData: paginatedActions,
  filteredTotal,
  page: pageActions,
  numPages: numPagesActions,
  goToPage: goToPageActions,
} = useTableFilter(
  actions,
  [
    (t: any) => t.code,
    (t: any) => t.route,
    (t: any) => t.description,
  ],
  15
);

  const errors = ref('');  
  const errorId = ref('');  
  const success = ref('');
  const errorsBis = {'name':'','valeur':'', 'mnoName':'', 'description':''};
  const pageLoad = ref(false);

  const formValues = reactive({    
    valeur: "",  
    name: "",

    mnoName: "",
    description: "",
    phoneCode: "",
    phoneMask: 0,
    paymentMethod: ""
    // heckOnlyAfterTimeout :false

  });

  
  const schema = yup.object({    
      // valeur: yup.number().required('La valeur est requise'),  
      name: yup.string().required('Le nom de l\'operateur  est requis'),   

      mnoName: yup.string().required('Le nom du mno est requis'),   
      description: yup.string().required('Le nom du mno est requis'),   
      phoneCode: yup.string().required('L\'indice telephonique est requis'),   
      phoneMask: yup.string().required('Le masque telephonique est requis'),   
      paymentMethod: yup.string().required('La methode de paiement est requise'),   
     
  });

const initField = () =>{
  formValues.name=  ''; 
  formValues.mnoName=  ""; 
  formValues.description=  ""; 
  formValues.phoneCode=  ""; 
  formValues.phoneMask=  0; 
  formValues.paymentMethod=  ""; 
  // selectedOrganization.value = code; 
  // selectedOperator.value = '';  
  // selectedTypeFee.value = '';  
  // selectedMode.value = '';  
  // selectedCountry.value = '';  
  itemCode = '';
  edit=0;
  // selectedPaymentMethod.value = '',
  selectedCountry.value = '' ,
  selectedOperationType.value = '',
  selectedProvider.value = '',
  selectedCheckOnlyAfterTimeout.value = false ,
  selectedStatus.value = '';
  errorId.value=''
  errors.value=''
}

  function handleOrganizationChange(event) {
      selectedOrganization.value = event.target.value;
    }

function handleOperatorChange(event) {
  selectedOperator.value = event.target.value;
}

function handleTypeFeeChange(event) {
  selectedTypeFee.value = event.target.value;
}

function handleCheckOnlyAfterTimeoutChange(event) {
  selectedCheckOnlyAfterTimeout.value = event.target.value;
}

// function handleCheckOnlyAfterTimeoutChange(event) {
//   selectedCheckOnlyAfterTimeout.value = event.target.value === "1";
// }


function handleModeChange(event) {
  selectedMode.value = event.target.value;
}

function handleStatusChange(event) {
  selectedStatus.value = event.target.value;
}

function handlePaymentMethodChange(event) {
  selectedPaymentMethod.value = event.target.value;
}

function handleOperationTypeChange(event) {
  selectedOperationType.value = event.target.value;
}

function handleProviderChange(event) {
  selectedProvider.value = event.target.value;
}

function handleCountryChange(event) {
  // selectedCountry.value = event.target.value;
  var i = 0;
  while(i<countriesTemp.length){    
      if(countriesTemp[i].countryCode == event.target.value){         
          selectedCountry.value=countriesTemp[i].code;
          countryCode = selectedCountry.value=countriesTemp[i].countryCode;
          countryName = selectedCountry.value=countriesTemp[i].name;
      }      
      i++;
  }
  // operators
  var j = 0;
  var operatorArr = new Array<Operator>();
  while(j<operatorsTemp.length){    
      if(operatorsTemp[j].countryCode == event.target.value){         
          operatorArr.push(operatorsTemp[j]);
      }      
      j++;
  }
   operators.value = operatorArr;
}

function formatDateFr(value){
    if(value){
        const year = value.getFullYear();
        let month =value.getMonth() + 1;
        month = month<10?'0'+month:month;
        let day = value.getDate();  
        day = day<10?'0'+day:day;      
        return day+'/'+month+'/'+year;
        
    }
}

const getFees = (arg=1) =>{
    // +arg    
    axios.get(backApi+'/secure/fees/?organization='+code,{    
      headers: {
            
            Authorization: `Bearer ${token}`
      } 
    })
    .then((response) => {        
        fees.value = response.data;  //.data.fees            
        
        // total.value=parseInt(response.data.pagination.total);
        // page.value=parseInt(response.data.pagination.page);
        // pagesLeft.value=parseInt(response.data.pagination.pagesLeft);
        // currentPage.value=parseInt(response.data.pagination.currentPage);
        // numPages.value=parseInt(response.data.pagination.numPages);

        total.value=10;
        page.value=1;
        pagesLeft.value=0;
        currentPage.value=1;
        numPages.value=1;
        
        // alert(total.value)
    }).catch((error) => {
          if( error.response){              
              if(error.response.status === 401){
                router.push('/')
                
              }   
              
          }
  });
}

const getOrganizations = () =>{

axios.get(backApi+'/secure/organizations/',{  
  headers: {
       
        Authorization: `Bearer ${token}`
  } 
})
.then((response) => {
    // users.value = response.data;
    organizations.value = response.data;  //.data.users          
    console.log(response.data);
    
    
}).catch((error) => {
      if( error.response){
          console.log(error.response.data); // => the response payload 
          if(error.response.status === 401){
            router.push('/')
            //window.location.href = '/';
            //router.push('/');
          }   
          
      }
});
//  loader.value=true;
}

// Récupère une page depuis l'API (forme { data, pagination })
const fetchProvidersPage = (targetPage: number) => {
  const url = `${backApi}/secure/providers/?page=${targetPage}`;

  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache, no-store'
    }
  });
}

// Charge TOUTES les pages de providers (boucle sur pagination.numPages)
const getProviders = async () => {
  try {
    const first = await fetchProvidersPage(1);
    const collected: any[] = [...first.data.data];
    const totalPages = first.data.pagination.numPages;

    if (totalPages > 1) {
      const remainingRequests = [];
      for (let p = 2; p <= totalPages; p++) {
        remainingRequests.push(fetchProvidersPage(p));
      }
      const results = await Promise.all(remainingRequests);
      results.forEach(r => collected.push(...r.data.data));
    }

    providers.value = collected;
  } catch (error: any) {
    if (error.response) {
      console.log(error.response.data);
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  }
}

const getTypeFees = () =>{

axios.get(backApi+'/secure/typefees/',{  
  headers: {
       
        Authorization: `Bearer ${token}`
  } 
})
.then((response) => {
    // users.value = response.data;
    typefees.value = response.data;  //.data.users          
    console.log(response.data);
    
    
}).catch((error) => {
      if( error.response){
          console.log(error.response.data); // => the response payload 
          if(error.response.status === 401){
            router.push('/')
            //window.location.href = '/';
            //router.push('/');
          }   
          
      }
});
//  loader.value=true;
}

const getCountries = () =>{

axios.get(backApi+'/secure/countries/',{  
  headers: {
       
        Authorization: `Bearer ${token}`
  } 
})
.then((response) => {
     countriesTemp = response.data;
    countries.value = response.data;  //.data.users          
    console.log(response.data);
    
    
}).catch((error) => {
      if( error.response){
          console.log(error.response.data); // => the response payload 
          if(error.response.status === 401){
            router.push('/')
            //window.location.href = '/';
            //router.push('/');
          }   
          
      }
});
//  loader.value=true;
}

const getOperators = () =>{

axios.get(backApi+'/secure/operators/',{  
headers: {
   
    Authorization: `Bearer ${token}`
} 
})
.then((response) => {
operatorsTemp = response.data;  //.data.users          
console.log("OP___",response.data);

}).catch((error) => {
  if( error.response){
      console.log(error.response.data); // => the response payload 
      if(error.response.status === 401){
        router.push('/')        
      }   
      
  }
});

}

// Récupère une page depuis l'API (forme { data, pagination })
const fetchActionsPage = (targetPage: number) => {
  const url = `${backApi}/secure/actions/?page=${targetPage}`;

  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache, no-store'
    }
  });
}

// Charge TOUTES les pages d'actions (boucle sur pagination.numPages)
const getActions = async () => {
  try {
    const first = await fetchActionsPage(1);
    const collected: any[] = [...first.data.data];
    const totalPages = first.data.pagination.numPages;

    if (totalPages > 1) {
      const remainingRequests = [];
      for (let p = 2; p <= totalPages; p++) {
        remainingRequests.push(fetchActionsPage(p));
      }
      const results = await Promise.all(remainingRequests);
      results.forEach(r => collected.push(...r.data.data));
    }

    actions.value = collected;
  } catch (error: any) {
    if (error.response) {
      console.log(error.response.data);
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  }
}

const changeStatus =(status,code)=>{
 // alert(code)
  axios.put(`${backApi}/secure/operators/${code}/status`,{
          code: code,
          status:  (status=='ACTIVE')?'INACTIVE':'ACTIVE'
        }, {  
      headers: {            
            Authorization: `Bearer ${token}`,
      }       
      }).then((response) => {        
        router.go();        
        
    }).catch((error) => {
          if( error.response){
              //console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                router.push('/')
                
              }   
              
          }
  });
}


const showOperator = (code) =>{
    // +arg
     axios.get(backApi+'/secure/operators/'+code+'/show',{    
      headers: {
            
            Authorization: `Bearer ${token}`
      } 
    })
    .then((response) => {        

        formValues.name = response.data.name;
        formValues.mnoName = response.data.mnoName;
        formValues.paymentMethod = response.data.paymentMethod;
        formValues.phoneCode = response.data.phoneCode;
        formValues.description = response.data.description;
        formValues.phoneMask = response.data.phoneMask;

        selectedStatus.value = response.data.status;
        selectedOperationType.value = response.data.operationType;
        selectedProvider.value = response.data.provider.code;
        selectedCountry.value = response.data.countryCode;
        selectedCheckOnlyAfterTimeout.value = response.data.checkOnlyAfterTimeout;

        itemCode = response.data.code;


        edit=1;        
        // console.log(response.data);
    }).catch((error) => {
          if( error.response){              
              if(error.response.status === 401){
                router.push('/')
                
              }else{
                console.log(error.response);
              }   
              
          }
  });
}

const save =()=>{
  if (edit==0){
    storeOperator()
  }else{
    updateProvidor()
  }
  
}

const storeOperator =()=>{
try {  
  schema.validateSync(formValues);
  // alert(formValues)
  axios.post(`${backApi}/secure/operators/new`,{          
          name:formValues.name,
          mnoName: formValues.mnoName ,
          status: selectedStatus.value ,
          paymentMethod: formValues.paymentMethod,
          countryCode: countryCode ,
          countryName: countryName ,
          phoneCode: formValues.phoneCode ,
          operationType: selectedOperationType.value ,
          description: formValues.description ,
          phoneMask: formValues.phoneMask ,
          provider: selectedProvider.value ,
          checkOnlyAfterTimeout: selectedCheckOnlyAfterTimeout.value
        }, {  
      headers: {            
            Authorization: `Bearer ${token}`,
           'Content-Type':'application/json',
      }       
      }).then((response) => {  
        if(response.status === 200){      
          showToast("Operateur "+formValues.name.toLowerCase()+" enregistré avec succès","green");
          initField();   
          // router.go();  
        }      
        
    }).catch((error) => {
      // alert(error.response.data.errorId);
          if( error.response){
              //console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                router.push('/')
                
              }else{
                errorId.value=error.response.data.errorId;
                errors.value=error.response.data.message;
              } 
              
          }
  });
} catch (error) {
        // console.log(error);        
         errors.value="une erreur inattendue est apparue"
         
              
}

// name:name.value,
// email:email.value,
// contact:contact.value,
// description:description.value
}

const updateProvidor =()=>{
  btnLoad.value=false;
  // console.log("PROVIDER___",selectedProvider.value)
  // console.log("DELAIS___",selectedCheckOnlyAfterTimeout.value)
try {  
  schema.validateSync(formValues);
  // alert(formValues)
  axios.put(`${backApi}/secure/operators/${itemCode}/edit`,{          
          name:formValues.name,
          description:formValues.description,

          mnoName: formValues.mnoName ,
          status: selectedStatus.value ,
          paymentMethod: formValues.paymentMethod,
          countryCode: countryCode ,
          countryName: countryName ,
          phoneCode: formValues.phoneCode ,
          operationType: selectedOperationType.value ,
          phoneMask: formValues.phoneMask ,
          provider: selectedProvider.value ,
          checkOnlyAfterTimeout: selectedCheckOnlyAfterTimeout.value,
        
          code:itemCode,     
        }, {  
      headers: {            
            Authorization: `Bearer ${token}`,
           'Content-Type':'application/json',
      }       
      }).then((response) => {            
        btnLoad.value=true;
        if(response.status === 200){   
          showToast("Modification effectuée avec succès","green");            
          router.go();  
        }      
        
    }).catch((error) => {
      btnLoad.value=true;
      // alert(error.response.data.errorId);
          if( error.response){
              //console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                router.push('/')
                
              }else{
                errorId.value=error.response.data.errorId;
                errors.value=error.response.data.message;
              } 
              
          }
  });
} catch (error) {
        // console.log(error);        
         errors.value="une erreur inattendue est apparue"
         btnLoad.value=true;       
              
}

}

function validate(field) {
      schema
        .validateAt(field, formValues)
        .then(() => {
          errorsBis[field] = "";
        })
        .catch(err => {
          errorsBis[field] = err.message;          
        });
        errors.value=''
}


onMounted(async () => { 
  checkSessionValidate(1)
   const route = useRoute();
   code = route.params.id;
   getFees();
   getOperators();
   await getProviders();
   await getActions();
   getOrganizations();
   getTypeFees();
   getCountries();
 
   setTimeout(function () {
    pageLoad.value=true; 
         },1000)
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!pageLoad.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[22] || (_cache[22] = [
          _createElementVNode("div", {
            class: "spinner-grow text-danger",
            style: {"width":"3rem","height":"3rem","margin-top":"25vh","margin-left":"42%","margin-bottom":"5vh"},
            role: "status"
          }, [
            _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (pageLoad.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(searchQuery) ? (searchQuery).value = $event : null)),
                type: "text",
                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                placeholder: "Rechercher..."
              }, null, 512), [
                [_vModelText, _unref(searchQuery)]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("table", _hoisted_7, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t('actions.code')), 1),
                    _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('actions.action')), 1),
                    _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('actions.description')), 1),
                    _cache[23] || (_cache[23] = _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                    }, null, -1))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(paginatedActions), (action) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: action.code
                    }, [
                      _createElementVNode("td", _hoisted_11, _toDisplayString(action.code), 1),
                      _createElementVNode("td", _hoisted_12, _toDisplayString(action.route === null ? '' : action.route), 1),
                      _createElementVNode("td", _hoisted_13, _toDisplayString(action.description === null ? '' : action.description), 1),
                      _cache[24] || (_cache[24] = _createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }, null, -1))
                    ]))
                  }), 128))
                ])
              ])
            ]),
            (_unref(filteredTotal)>0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  (_unref(filteredTotal)>10)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
                        _createTextVNode(_toDisplayString(_ctx.$t('actions.showing')) + " ", 1),
                        _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(pageActions)*10), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('actions.outOf')) + " ", 1),
                        _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(filteredTotal)), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('actions.results')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(filteredTotal)<=10)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
                        _createTextVNode(_toDisplayString(_ctx.$t('actions.showing')) + " ", 1),
                        _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(filteredTotal)), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('actions.outOf')) + " ", 1),
                        _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(filteredTotal)), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('actions.results')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("nav", _hoisted_21, [
                    _createElementVNode("ul", _hoisted_22, [
                      ((_unref(pageActions)-1)>0)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_23, [
                            _createElementVNode("a", {
                              class: "page-link",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(goToPageActions)(_unref(pageActions)-1))),
                              "aria-label": "Previous"
                            }, [...(_cache[25] || (_cache[25] = [
                              _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
                            ]))])
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(numPagesActions), (numPage) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: numPage,
                          class: "page-item"
                        }, [
                          (numPage==_unref(pageActions))
                            ? (_openBlock(), _createElementBlock("a", _hoisted_24, _toDisplayString(numPage), 1))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                class: "page-link",
                                onClick: ($event: any) => (_unref(goToPageActions)(numPage))
                              }, _toDisplayString(numPage), 9, _hoisted_25))
                        ]))
                      }), 128)),
                      ((_unref(pageActions)+1)<=_unref(numPagesActions))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_26, [
                            _createElementVNode("a", {
                              class: "page-link",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(goToPageActions)(_unref(pageActions)+1))),
                              "aria-label": "Next"
                            }, [...(_cache[26] || (_cache[26] = [
                              _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
                            ]))])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("form", {
            onSubmit: _withModifiers(save, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("h1", _hoisted_31, _toDisplayString(_unref(edit) == 0 ? _ctx.$t('actions.addAction') : _ctx.$t('actions.editAction')), 1),
              _cache[27] || (_cache[27] = _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_32, [
              (errors.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _createElementVNode("h6", _hoisted_34, _toDisplayString(errorId.value), 1),
                    _createElementVNode("h6", _hoisted_35, _toDisplayString(errors.value), 1)
                  ]))
                : _createCommentVNode("", true),
              (success.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                    _createElementVNode("h6", _hoisted_37, _toDisplayString(success.value), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.$t('actions.name')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formValues.name) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['name'] }]),
                        id: "lead-calendar",
                        placeholder: _ctx.$t('actions.namePlaceholder'),
                        onBlur: _cache[4] || (_cache[4] = ($event: any) => (validate('name'))),
                        onKeyup: _cache[5] || (_cache[5] = ($event: any) => (validate('name')))
                      }, null, 42, _hoisted_42), [
                        [_vModelText, formValues.name]
                      ]),
                      _createElementVNode("span", _hoisted_43, _toDisplayString(errorsBis['name']), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("label", _hoisted_45, _toDisplayString(_ctx.$t('actions.mno')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formValues.mnoName) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['mnoName'] }]),
                        id: "lead-calendar",
                        placeholder: _ctx.$t('actions.mnoPlaceholder'),
                        onBlur: _cache[7] || (_cache[7] = ($event: any) => (validate('mnoName'))),
                        onKeyup: _cache[8] || (_cache[8] = ($event: any) => (validate('mnoName')))
                      }, null, 42, _hoisted_46), [
                        [_vModelText, formValues.mnoName]
                      ]),
                      _createElementVNode("span", _hoisted_47, _toDisplayString(errorsBis['mnoName']), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("label", _hoisted_50, _toDisplayString(_ctx.$t('actions.status')), 1),
                    _createElementVNode("select", {
                      name: "status",
                      id: "status",
                      class: "form-select fs-md-15 text-black shadow-none",
                      onChange: handleStatusChange,
                      required: ""
                    }, [
                      _createElementVNode("option", {
                        value: "",
                        selected: selectedStatus.value==''
                      }, _toDisplayString(_ctx.$t('actions.select')), 9, _hoisted_51),
                      _createElementVNode("option", {
                        value: "ACTIVE",
                        selected: selectedStatus.value=='ACTIVE'
                      }, "ACTIVE", 8, _hoisted_52),
                      _createElementVNode("option", {
                        value: "INACTIVE",
                        selected: selectedStatus.value=='INACTIVE'
                      }, "INACTIVE", 8, _hoisted_53)
                    ], 32)
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.$t('actions.paymentMethod')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formValues.paymentMethod) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['paymentMethod'] }]),
                        id: "lead-calendar",
                        placeholder: _ctx.$t('actions.paymentMethodPlaceholder'),
                        onBlur: _cache[10] || (_cache[10] = ($event: any) => (validate('paymentMethod'))),
                        onKeyup: _cache[11] || (_cache[11] = ($event: any) => (validate('paymentMethod')))
                      }, null, 42, _hoisted_56), [
                        [_vModelText, formValues.paymentMethod]
                      ]),
                      _createElementVNode("span", _hoisted_57, _toDisplayString(errorsBis['paymentMethod']), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("label", _hoisted_60, _toDisplayString(_ctx.$t('actions.phoneCode')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formValues.phoneCode) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['phoneCode'] }]),
                        id: "lead-calendar",
                        placeholder: _ctx.$t('actions.phoneCodePlaceholder'),
                        onBlur: _cache[13] || (_cache[13] = ($event: any) => (validate('phoneCode'))),
                        onKeyup: _cache[14] || (_cache[14] = ($event: any) => (validate('phoneCode')))
                      }, null, 42, _hoisted_61), [
                        [_vModelText, formValues.phoneCode]
                      ]),
                      _createElementVNode("span", _hoisted_62, _toDisplayString(errorsBis['phoneCode']), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_63, [
                    _createElementVNode("label", _hoisted_64, _toDisplayString(_ctx.$t('actions.operationType')), 1),
                    _createElementVNode("select", {
                      name: "operationType",
                      id: "operationType",
                      class: "form-select fs-md-15 text-black shadow-none",
                      onChange: handleOperationTypeChange,
                      required: ""
                    }, [
                      _createElementVNode("option", {
                        value: "",
                        selected: selectedOperationType.value==''
                      }, _toDisplayString(_ctx.$t('actions.select')), 9, _hoisted_65),
                      _createElementVNode("option", {
                        value: "1",
                        selected: selectedOperationType.value=='1'
                      }, _toDisplayString(_ctx.$t('actions.payin')), 9, _hoisted_66),
                      _createElementVNode("option", {
                        value: "2",
                        selected: selectedOperationType.value=='2'
                      }, _toDisplayString(_ctx.$t('actions.payout')), 9, _hoisted_67),
                      _createElementVNode("option", {
                        value: "3",
                        selected: selectedOperationType.value=='3'
                      }, _toDisplayString(_ctx.$t('actions.payinPayout')), 9, _hoisted_68)
                    ], 32)
                  ])
                ]),
                _createElementVNode("div", _hoisted_69, [
                  _createElementVNode("div", _hoisted_70, [
                    _createElementVNode("label", _hoisted_71, _toDisplayString(_ctx.$t('actions.provider')), 1),
                    _createElementVNode("select", {
                      name: "provider",
                      id: "provider",
                      class: "form-select fs-md-15 text-black shadow-none",
                      onChange: handleProviderChange,
                      required: ""
                    }, [
                      _createElementVNode("option", _hoisted_72, _toDisplayString(_ctx.$t('actions.select')), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(providers.value, (provider) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: provider.code,
                          key: provider.code,
                          selected: selectedProvider.value==provider.code
                        }, _toDisplayString(provider.name), 9, _hoisted_73))
                      }), 128))
                    ], 32)
                  ]),
                  _createElementVNode("div", _hoisted_74, [
                    _createElementVNode("label", _hoisted_75, _toDisplayString(_ctx.$t('actions.activationDelay')), 1),
                    _withDirectives(_createElementVNode("select", {
                      name: "checkOnlyAfterTimeout",
                      id: "checkOnlyAfterTimeout",
                      class: "form-select fs-md-15 text-black shadow-none",
                      onChange: handleCheckOnlyAfterTimeoutChange,
                      required: "",
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((selectedCheckOnlyAfterTimeout).value = $event))
                    }, [
                      _createElementVNode("option", {
                        value: "",
                        selected: selectedPaymentMethod.value==''
                      }, _toDisplayString(_ctx.$t('actions.select')), 9, _hoisted_76),
                      _createElementVNode("option", _hoisted_77, _toDisplayString(_ctx.$t('actions.inactive')), 1),
                      _createElementVNode("option", _hoisted_78, _toDisplayString(_ctx.$t('actions.active')), 1)
                    ], 544), [
                      [_vModelSelect, selectedCheckOnlyAfterTimeout.value]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_79, [
                  _createElementVNode("div", _hoisted_80, [
                    _createElementVNode("label", _hoisted_81, _toDisplayString(_ctx.$t('actions.phoneMask')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formValues.phoneMask) = $event)),
                        type: "number",
                        min: "0",
                        max: "15",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['phoneMask'] }]),
                        id: "lead-calendar",
                        placeholder: _ctx.$t('actions.phoneMaskPlaceholder'),
                        onBlur: _cache[17] || (_cache[17] = ($event: any) => (validate('phoneMask'))),
                        onKeyup: _cache[18] || (_cache[18] = ($event: any) => (validate('phoneMask')))
                      }, null, 42, _hoisted_82), [
                        [_vModelText, formValues.phoneMask]
                      ]),
                      _createElementVNode("span", _hoisted_83, _toDisplayString(errorsBis['phoneMask']), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_84, [
                    _createElementVNode("label", _hoisted_85, _toDisplayString(_ctx.$t('actions.country')), 1),
                    _createElementVNode("select", {
                      name: "country",
                      id: "country",
                      class: "form-select fs-md-15 text-black shadow-none",
                      onChange: handleCountryChange,
                      required: ""
                    }, [
                      _createElementVNode("option", _hoisted_86, _toDisplayString(_ctx.$t('actions.select')), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(countries.value, (country) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: country.countryCode,
                          key: country.code,
                          selected: selectedCountry.value==country.countryCode
                        }, _toDisplayString(country.name), 9, _hoisted_87))
                      }), 128))
                    ], 32)
                  ])
                ]),
                _createElementVNode("div", _hoisted_88, [
                  _createElementVNode("div", _hoisted_89, [
                    _createElementVNode("label", _hoisted_90, _toDisplayString(_ctx.$t('actions.description')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((formValues.description) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['description'] }]),
                        id: "lead-calendar",
                        placeholder: _ctx.$t('actions.descriptionPlaceholder'),
                        onBlur: _cache[20] || (_cache[20] = ($event: any) => (validate('description'))),
                        onKeyup: _cache[21] || (_cache[21] = ($event: any) => (validate('description')))
                      }, null, 42, _hoisted_91), [
                        [_vModelText, formValues.description]
                      ]),
                      _createElementVNode("span", _hoisted_92, _toDisplayString(errorsBis['description']), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_93, [
              (_unref(current_permissions)('create_operator', 'edit_operator'))
                ? (_openBlock(), _createElementBlock("button", _hoisted_94, [
                    _cache[28] || (_cache[28] = _createElementVNode("i", {
                      class: "flaticon-plus position-relative ms-5 fs-12",
                      style: {"color":"#FFF"}
                    }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_unref(edit) == 0 ? _ctx.$t('actions.save') : _ctx.$t('actions.edit')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 32)
        ])
      ])
    ]),
    _cache[29] || (_cache[29] = _createElementVNode("div", { id: "snackbar" }, null, -1))
  ], 64))
}
}

})